import type { UseFormSetError, FieldValues, Path } from 'react-hook-form';
import { ApiError } from './errors';

/**
 * Maps server-side validation field errors back onto the form.
 * Call this in a mutation's onError. The global QueryClient handler skips
 * validation errors, so there is no double-reporting.
 */
export function applyServerErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
): void {
  if (!(error instanceof ApiError) || !error.isValidation()) return;

  for (const [field, messages] of Object.entries(error.fieldErrors ?? {})) {
    setError(field as Path<T>, { type: 'server', message: messages[0] });
  }
}
